$('#optiontype').on('change', function() {
  var selectoption = $(this).val();
  //console.log("selectoption", selectoption); 
  $("#optionshade").prop("selectedIndex", 0);
  $(".find-pdplink a").attr("href", "javascript:void(0)");
  $(".option_sec").hide();
  $(`[value="${selectoption}"]`).show();
});


$('#optionshade').on('change', function() { 
  var dataLink = $(this).find(":selected").data("link");
  console.log("dataLink", dataLink);   
  $(".find-pdplink a").attr("href", dataLink);
}); 

document.getElementById('shopify-block-2412377359038555501').innerHTML = '';
<!---- writer text script ----->
const texts = ['Search For Liquid Detergent…','Search For Powder Detergent…','Search For Laundry Sheets…','Search For Fabric Conditione…','Search For Baby Detergent…'];
const input = document.querySelector('#searchbox');
const animationWorker = function (input, texts) {
  this.input = input;
  this.defaultPlaceholder = this.input.getAttribute('placeholder');
  this.texts = texts;
  this.curTextNum = 0;
  this.curPlaceholder = '';
  this.blinkCounter = 0;
  this.animationFrameId = 0;
  this.animationActive = false;
  this.input.setAttribute('placeholder',this.curPlaceholder);

  this.switch = (timeout) => {
    this.input.classList.add('imitatefocus');
    setTimeout(
      () => { 
        this.input.classList.remove('imitatefocus');
        if (this.curTextNum == 0) 
          this.input.setAttribute('placeholder',this.defaultPlaceholder);
        else
          this.input.setAttribute('placeholder',this.curPlaceholder);

        setTimeout(
          () => { 
            this.input.setAttribute('placeholder',this.curPlaceholder);
            if(this.animationActive) 
              this.animationFrameId = window.requestAnimationFrame(this.animate)}, 
          timeout);
      }, 
      timeout);
  }

  this.animate = () => {
    if(!this.animationActive) return;
    let curPlaceholderFullText = this.texts[this.curTextNum];
    let timeout = 20;
    if (this.curPlaceholder == curPlaceholderFullText+'|' && this.blinkCounter==3) {
      this.blinkCounter = 0;
      this.curTextNum = (this.curTextNum >= this.texts.length-1)? 0 : this.curTextNum+1;
      this.curPlaceholder = '|';
      this.switch(1000);
      return;
    }
    else if (this.curPlaceholder == curPlaceholderFullText+'|' && this.blinkCounter<3) {
      this.curPlaceholder = curPlaceholderFullText;
      this.blinkCounter++;
    }
    else if (this.curPlaceholder == curPlaceholderFullText && this.blinkCounter<3) {
      this.curPlaceholder = this.curPlaceholder+'|';
    }
    else {
      this.curPlaceholder = curPlaceholderFullText
        .split('')
        .slice(0,this.curPlaceholder.length+1)
        .join('') + '|';
      timeout = 150;
    }
    this.input.setAttribute('placeholder',this.curPlaceholder);
    setTimeout(
      () => { if(this.animationActive) this.animationFrameId = window.requestAnimationFrame(this.animate)}, 
      timeout);
  }

  this.stop = () => {
    this.animationActive = false;
    window.cancelAnimationFrame(this.animationFrameId);
  }

  this.start = () => {
    this.animationActive = true;
    this.animationFrameId = window.requestAnimationFrame(this.animate);
    return this;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  let aw = new animationWorker(input, texts).start();
  input.addEventListener("focus", (e) => aw.stop());
  input.addEventListener("blur", (e) => {
    aw = new animationWorker(input, texts);
    if(e.target.value == '') setTimeout( aw.start, 2000);
  });
});
setTimeout(function(){
      $('body').show();
       $(".image-wrap img").css("opacity", 1);
    },5000)

 // Define a function to be executed when the window is fully loaded
function onLoadHandler() {
  var parents = document.querySelectorAll('.qsc2-product-item-wrapper');
  var buttonplus = document.querySelector('.qsc2-quantity-btn--plus');
  var buttonminus = document.querySelector('.qsc2-quantity-btn--minus');
  parents.forEach(function(parent) {
    if (parent.textContent.includes('Special Offer')) {
      parent.classList.add('hide-quantity');
    }
  });
}

// Execute the code when the window is fully loaded
window.addEventListener('load', function() {
  onLoadHandler();
});

setInterval(function() {
  onLoadHandler();
  //alert('hello');
}, 500);


$(window).on('load', function(){  
  setTimeout(function(){
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
        console.log(cart)
        var data_price_100 = 0;
        var total_count = '0';
        $(cart.items).each(function(index,item){
        if(item.final_price == '100'){
          data_price_100++;
        }
          console.log(data_price_100)
        });
        console.log('data_price_100',data_price_100)

        setTimeout(function(){
        $(cart.items).each(function(index,item){
          if(data_price_100 <= 1){
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
            console.log('0')
          }
          }
          if(data_price_100 > 1){
            
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
             total_count = '1';
            console.log('1')
          }
            if(total_count == '1'){
            if(item.final_price == '100'){
              console.log('1 1')
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 0, id: data_id });
          }
            }
          }
        })
          $('.cart__page').load(' .cart__page', function(){
       });
          }, 100)
      })
      }, 1000)
  setTimeout(function(){
        $('.cart__page').load(' .cart__page', function(){
       });
      }, 2000)
})
     
    $(document).ready(function(){

      $('.add-to-cart').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var data_id = $('.product-single__variants option:selected').val();
        $.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: data_id
},
  dataType: 'json', 
 success: function (data) { 
  setTimeout(function(){
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
        console.log(cart)
        var data_price_100 = 0;
        var total_count = '0';
        $(cart.items).each(function(index,item){
        if(item.final_price == '100'){
          data_price_100++;
        }
          console.log(data_price_100)
        });
        console.log('data_price_100',data_price_100)

        setTimeout(function(){
        $(cart.items).each(function(index,item){
          if(data_price_100 <= 1){
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
            console.log('0')
          }
          }
          if(data_price_100 > 1){
            
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
             total_count = '1';
            console.log('1')
          }
            if(total_count == '1'){
            if(item.final_price == '100'){
              console.log('1 1')
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 0, id: data_id });
          }
            }
          }
        })
          $('.cart__page').load(' .cart__page', function(){
       });
          }, 100)
      })
      }, 1000)
   setTimeout(function(){
     $('.cart__page').load(' .cart__page', function(){
       });
   }, 3000)
 } 
 });
        return false;
      })

      $(document).on('click','.add-to-cart', function(e){
        e.preventDefault();
        e.stopPropagation();
        var data_id = $('.product-single__variants option:selected').val();
        $.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: data_id
},
  dataType: 'json', 
 success: function (data) { 
  setTimeout(function(){
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
        console.log(cart)
        var data_price_100 = 0;
        var total_count = '0';
        $(cart.items).each(function(index,item){
        if(item.final_price == '100'){
          data_price_100++;
        }
          console.log(data_price_100)
        });
        console.log('data_price_100',data_price_100)

        setTimeout(function(){
        $(cart.items).each(function(index,item){
          if(data_price_100 <= 1){
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
            console.log('0')
          }
          }
          if(data_price_100 > 1){
            
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
             total_count = '1';
            console.log('1')
          }
            if(total_count == '1'){
            if(item.final_price == '100'){
              console.log('1 1')
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 0, id: data_id });
          }
            }
          }
        })
          $('.cart__page').load(' .cart__page', function(){
       });
          }, 100)
      })
      }, 1000)
   setTimeout(function(){
     $('.cart__page').load(' .cart__page', function(){
       });
   }, 3000)
 } 
 });
        return false;
      })
      
      jQuery.getJSON('/cart.js', function (cart, textStatus) {
        console.log(cart)
        var data_price_100 = 0;
        var total_count = '0';
        $(cart.items).each(function(index,item){
        if(item.final_price == '100'){
          data_price_100++;
        }
          console.log(data_price_100)
        });
        console.log('data_price_100',data_price_100)

        setTimeout(function(){
        $(cart.items).each(function(index,item){
          if(data_price_100 <= 1){
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
            console.log('0')
          }
          }
          if(data_price_100 > 1){
            
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
             total_count = '1';
            console.log('1')
          }
            if(total_count == '1'){
            if(item.final_price == '100'){
              console.log('1 1')
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 0, id: data_id });
          }
            }
          }
        })

          $('.cart__page').load(' .cart__page', function(){
       });
          }, 100)
      })

      setTimeout(function(){
        jQuery.getJSON('/cart.js', function (cart, textStatus) {
        console.log(cart)
        var data_price_100 = 0;
        var total_count = '0';
        $(cart.items).each(function(index,item){
        if(item.final_price == '100'){
          data_price_100++;
        }
          console.log(data_price_100)
        });
        console.log('data_price_100',data_price_100)

        setTimeout(function(){
        $(cart.items).each(function(index,item){
          if(data_price_100 <= 1){
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
            console.log('0')
          }
          }
          if(data_price_100 > 1){
            
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
             total_count = '1';
            console.log('1')
          }
            if(total_count == '1'){
            if(item.final_price == '100'){
              console.log('1 1')
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 0, id: data_id });
          }
            }
          }
        })
          $('.cart__page').load(' .cart__page', function(){
       });
          }, 100)
      })
      }, 2000)

      setTimeout(function(){
        $('.cart__page').load(' .cart__page', function(){
       });
      }, 1500)

      setTimeout(function(){
        $('.cart__page').load(' .cart__page', function(){
       });
      }, 2500)

      setTimeout(function(){
        $('.cart__page').load(' .cart__page', function(){
       });
      }, 3500)

      
      $('.qsc2-basic.qsc2-checkout-button').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        console.log('iff')
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
        console.log(cart)
        var data_price_100 = 0;
        var total_count = '0';
        $(cart.items).each(function(index,item){
        if(item.final_price == '100'){
          data_price_100++;
        }
          console.log(data_price_100)
        });
        console.log('data_price_100',data_price_100)

        setTimeout(function(){
        $(cart.items).each(function(index,item){
          if(data_price_100 <= 1){
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
            console.log('0')
          }
          }
          if(data_price_100 > 1){
            
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
             total_count = '1';
            console.log('1')
          }
            if(total_count == '1'){
            if(item.final_price == '100'){
              console.log('1 1')
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 0, id: data_id });
          }
            }
          }
        })
          }, 100)
      })
        setTimeout(function(){
        //  window.location.href = '/checkout'
        }, 3000)
        return false;
      })
      $(document).on('click','.qsc2-basic.qsc2-checkout-button', function(e){
         e.preventDefault();
        e.stopPropagation();
        console.log('else')
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
        console.log(cart)
        var data_price_100 = 0;
        var total_count = '0';
        $(cart.items).each(function(index,item){
        if(item.final_price == '100'){
          data_price_100++;
        }
          console.log(data_price_100)
        });
        console.log('data_price_100',data_price_100)

        setTimeout(function(){
        $(cart.items).each(function(index,item){
          if(data_price_100 <= 1){
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
            console.log('0')
          }
          }
          if(data_price_100 > 1){
            
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
             total_count = '1';
            console.log('1')
          }
            if(total_count == '1'){
            if(item.final_price == '100'){
              console.log('1 1')
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 0, id: data_id });
          }
            }
          }
        })
          }, 100)
      })
        setTimeout(function(){
         // window.location.href = '/checkout'
        }, 3000)
        return false;
      })


      $('[name="checkout"]').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        console.log('main')
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
        console.log(cart)
        var data_price_100 = 0;
        var total_count = '0';
        $(cart.items).each(function(index,item){
        if(item.final_price == '100'){
          data_price_100++;
        }
          console.log(data_price_100)
        });
        console.log('data_price_100',data_price_100)

        setTimeout(function(){
        $(cart.items).each(function(index,item){
          if(data_price_100 <= 1){
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
            console.log('0')
          }
          }
          if(data_price_100 > 1){
            
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
             total_count = '1';
            console.log('1')
          }
            if(total_count == '1'){
            if(item.final_price == '100'){
              console.log('1 1')
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 0, id: data_id });
          }
            }
          }
        })
          }, 100)
      })
        setTimeout(function(){
         // window.location.href = '/checkout'
        }, 3000)
        return false;
      })
      $(document).on('click','[name="checkout"]', function(e){
         e.preventDefault();
        e.stopPropagation();
        console.log('main else')
         jQuery.getJSON('/cart.js', function (cart, textStatus) {
        console.log(cart)
        var data_price_100 = 0;
        var total_count = '0';
        $(cart.items).each(function(index,item){
        if(item.final_price == '100'){
          data_price_100++;
        }
          console.log(data_price_100)
        });
        console.log('data_price_100',data_price_100)

        setTimeout(function(){
        $(cart.items).each(function(index,item){
          if(data_price_100 <= 1){
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
            console.log('0')
          }
          }
          if(data_price_100 > 1){
            
          if(item.final_price == '100'){
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 1, id: data_id });
             total_count = '1';
            console.log('1')
          }
            if(total_count == '1'){
            if(item.final_price == '100'){
              console.log('1 1')
            var data_id = item.id;
            console.log('item.final_price',item.id,item.final_price)
            jQuery.post('/cart/change.js', { quantity: 0, id: data_id });
          }
            }
          }
        })
          }, 100)
      })
        setTimeout(function(){
        //  window.location.href = '/checkout'
        }, 3000)
        return false;
      })
    })

    